import { Component, ChangeDetectionStrategy, computed, DestroyRef, effect, inject } from '@angular/core';
import { GridApi, IHeaderParams } from 'ag-grid-community';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { tap } from 'rxjs/operators';
import { IrisDmsGlobalSandbox } from '@iris/common/modules/dms/sandbox/dms-global.sandbox';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StrakitCheckboxComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'dms-grid-filter-checkbox-header-template',
  imports: [
    ReactiveFormsModule,

    StrakitCheckboxComponent,
  ],
  templateUrl: './dms-grid-filter-checkbox-header-template.component.html',
  styleUrls: ['./dms-grid-filter-checkbox-header-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridFilterCheckboxHeaderTemplateComponent implements IHeaderAngularComp {
  private readonly dmsGlobalSandbox = inject(IrisDmsGlobalSandbox);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);
  private readonly destroyRef = inject(DestroyRef);

  readonly valueControl = new FormControl(false);
  readonly selectedItemsCount = this.dmsFilesSandbox.selectedItemsCount;
  readonly contentPageCount = this.dmsFilesSandbox.contentPageCount;
  readonly selected = computed(() => this.selectedItemsCount() > 0 && this.selectedItemsCount() === (this.contentPageCount() - 1));
  readonly indeterminate = computed(() => this.selectedItemsCount() > 0 && this.selectedItemsCount() < (this.contentPageCount() - 1));

  private params: IHeaderParams;

  readonly controlEffect = effect(() => {
    this.valueControl.patchValue(this.selected(), { emitEvent: false });
  });

  get api(): GridApi {
    return this.params?.api;
  }

  agInit(params: IHeaderParams): void {
    this.params = params;

    this.valueControl.valueChanges.pipe(
      tap((value) => this.checkboxClicked(value)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return true;
  }

  checkboxClicked(checked: boolean): void {
    if (!checked) {
      this.dmsGlobalSandbox.setCheckAll(false);
      this.dmsFilesSandbox.resetSelection();
    } else {
      const page = this.api.paginationGetCurrentPage();
      const limit = this.api.paginationGetPageSize();
      const offset = page * limit;
      const ids = [];
      this.api.forEachNode((node) => {
        if (node.rowIndex >= offset && node.rowIndex < offset + limit) {
          ids.push(node.data.id);
        }
      });
      this.dmsFilesSandbox.toggleEntitiesSelection(ids, []);
    }
  }
}

